/**
 * This is a client-side latency measurement utility that is heavily inspired by Performance API
 * (https://developer.mozilla.org/en-US/docs/Web/API/Performance_API). The aim of using a custom
 * implementation instead of Performance API itself is because Performance API is not supported
 * by react native.
 */

const marks = [];
const getEntriesByName = (markName) =>
  marks.filter(({ name }) => name === markName);

const mark = (markName) => {
  marks.push({
    name: markName,
    startTime: new Date().getTime(),
    entryType: 'mark',
  });
};

const measure = (measureName, startMark) => {
  const markEntries = getEntriesByName(startMark);
  if (!markEntries.length) {
    throw new Error('Given mark not found');
  }

  const measureEntry = {
    name: measureName,
    duration: new Date().getTime() - markEntries[0].startTime,
    entryType: 'measure',
  };
  marks.push(measureEntry);
  return measureEntry;
};

const clearMarks = () => {
  marks.splice(0, marks.length);
};

export default {
  mark,
  measure,
  getEntriesByName,
  clearMarks,
};
